const UnderConstructionModal = ({ title = "Coming Soon", onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "420px" }}>

        <div className="modal-header">
          <div className="modal-title">{title}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body" style={{ textAlign: "center", padding: "40px 24px" }}>
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>🚧</div>
          <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "8px", color: "var(--text-primary, #1a1a2e)" }}>
            Under Construction
          </div>
          <div style={{ fontSize: "14px", color: "var(--text-secondary, #6b7280)" }}>
            This feature is coming soon. Check back later.
          </div>
        </div>

        <div className="modal-footer">
          <button className="org-btn-save" onClick={onClose}>Close</button>
        </div>

      </div>
    </div>
  );
};

export default UnderConstructionModal;
